import { turboproApi } from '@/api/turbopro';
import type { GravarAgendamentoPayload } from '../types';
import { getRelatoriosHeaders } from './shared';

export async function gravarAgendamentoApi(payload: GravarAgendamentoPayload): Promise<void> {
  await turboproApi<null>('Relatorios/GravarAgendamento', {
    method: 'POST',
    body: payload,
    headers: getRelatoriosHeaders(),
  });
}
